<template>
  <v-dialog v-model="dialog" scrollable max-width="1000px" persistent>
    <v-card>
      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-title>Process Change of Lessee</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 80vh">
          <v-stepper v-model="colStep">
            <v-stepper-header>
              <v-stepper-step :complete="colStep > 1" step="1">
                Choose an existing customer
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="colStep > 2" step="2">
                Choose/Create new customer
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <div style="padding-top: 10px">
                    <v-layout row>
                      <v-flex xs4>
                        <vonex-text
                          v-model="SearchText"
                          :options="fieldConditions"
                          hide-details
                          name="Search"
                          label="Search"
                          append-icon="search"
                        ></vonex-text>
                        <!-- <v-text-field
                        name="Search"
                        label="Search"
                        v-model="SearchText"
                        append-icon="search"
                      ></v-text-field> -->
                      </v-flex>
                    </v-layout>
                  </div>
                  <v-data-table
                    v-model="selectFormerCust"
                    :headers="headers"
                    :items="customersList"
                    :search="SearchText"
                    item-key="ubAccountNo"
                    :pagination.sync="pagination"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="text-md-center">
                          <v-radio-group
                            v-model="selectedFormerCust"
                            class="mt-1"
                            hide-details
                          >
                            <v-radio
                              :value="props.item.ubAccountNo"
                              @click="formerCustomerSelect(props)"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-md-center">
                          {{ props.item.ubAccountNo }}
                        </td>
                        <td class="text-md-center">
                          {{ props.item.firstName }}
                        </td>
                        <td class="text-md-center">{{ props.item.surname }}</td>
                        <td class="text-md-left">
                          {{ props.item.companyDetails.companyName }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <div style="padding-top: 10px">
                    <v-layout row>
                      <v-flex xs4>
                        <vonex-text
                          v-model="SearchText"
                          :options="fieldConditions"
                          hide-details
                          name="Search"
                          label="Search"
                          append-icon="search"
                        ></vonex-text>
                        <!-- <v-text-field
                        name="Search"
                        label="Search"
                        v-model="SearchText"
                        append-icon="search"
                      ></v-text-field> -->
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="createCustomer">
                        Add New
                      </v-btn>
                      <v-dialog
                        v-model="addNewCustomer"
                        max-width="1000px"
                        persistent
                      ></v-dialog>
                    </v-layout>
                  </div>
                  <v-data-table
                    v-model="selectNewCust"
                    :headers="headers"
                    :items="
                      customersList.filter(
                        (x) =>
                          x.ubAccountNo !==
                          $store.getters['orders/changeLessee/formerCustomer']
                            .ubAccountNo
                      )
                    "
                    :search="SearchText"
                    item-key="ubAccountNo"
                    :pagination.sync="pagination"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="text-md-center">
                          <v-radio-group
                            v-model="selectedNewCust"
                            class="mt-1"
                            hide-details
                          >
                            <v-radio
                              :value="props.item.ubAccountNo"
                              @click="newCustomerSelect(props)"
                            ></v-radio>
                          </v-radio-group>
                        </td>
                        <td class="text-md-center">
                          {{ props.item.ubAccountNo }}
                        </td>
                        <td class="text-md-center">
                          {{ props.item.firstName }}
                        </td>
                        <td class="text-md-center">{{ props.item.surname }}</td>
                        <td class="text-md-left">
                          {{ props.item.companyDetails.companyName }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <create-new-customer
            :dialog="addNewCustomer"
            @closeCustomerDialog="closeCustomerDialog"
          ></create-new-customer>

          <v-dialog v-model="processChangeOfLessee" persistent width="500">
            <v-card color="primary" dark>
              <v-card-text>
                Processing Change of Lessee...Please wait...
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions v-if="colStep == 1">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!selectedFormerCust"
            @click="
              colStep = 2;
              SearchText = '';
            "
          >
            Continue
          </v-btn>
          <v-btn color="light-grey" @click="close">Cancel</v-btn>
        </v-card-actions>

        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!selectedNewCust"
            @click="navigateLesseeOrder"
          >
            Continue
          </v-btn>
          <v-btn color="light-grey" @click="colStep = 1">Back</v-btn>
        </v-card-actions>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CreateNewCustomer from '@/components/create-new-customer';
const {
  mapActions: mapOrderActions,
  mapMutations: mapOrderMutations,
  mapGetters: mapOrderGetters,
} = createNamespacedHelpers(`orders`);
const { mapActions: mapIPVoiceActions } =
  createNamespacedHelpers(`orders/ipVoice`);
const { mapMutations: mapCustomerMutations } =
  createNamespacedHelpers(`orders/customer`);
const { mapActions: mapChangeLesseeActions } =
  createNamespacedHelpers(`orders/changeLessee`);

export default {
  name: 'ChangeLesseeDialogs',
  components: {
    CreateNewCustomer,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      },
    },
  },
  data: () => ({
    customersList: [],
    colStep: 0,
    SearchText: null,
    propCustomerData: [],
    selectNewCust: [],
    selectFormerCust: [],
    selectedNewCust: '',
    selectedFormerCust: '',
    addNewCustomer: false,
    pagination: { rowsPerPage: 10 },
    headers: [
      {
        text: 'Select',
        align: 'left',
        sortable: false,
        value: 'true',
      },
      {
        text: 'Vonex Account No.',
        align: 'center',
        sortable: true,
        value: 'ubAccountNo',
      },
      {
        text: 'First Name',
        align: 'center',
        sortable: true,
        value: 'firstName',
      },
      {
        text: 'Surname',
        align: 'center',
        sortable: true,
        value: 'surname',
      },
      {
        text: 'Company Name',
        align: 'left',
        sortable: true,
        value: 'companyname',
      },
    ],
  }),
  methods: {
    ...mapOrderActions([
      'addOrder',
      'getOrder',
      'resetOrder',
      'listOrders',
      'removeOrder',
    ]),
    ...mapOrderMutations(['setOrderType', 'setResidential']),
    ...mapIPVoiceActions(['setMessage', 'getServices']),
    ...mapCustomerMutations(['setDealerCustomers']),
    ...mapChangeLesseeActions(['assignNewCustomer', 'assignFormerCustomer']),
    refreshCustomers(args) {},
    closeCustomerDialog() {
      this.addNewCustomer = false;
      // this.$store.dispatch('orders/company/resetCompany');
      // this.$store.dispatch('orders/customer/resetCustomer');
      // this.$store.dispatch('orders/address/resetAddress');
      this.$store.dispatch('orders/resetOrder');
      this.loadDealerCustomers();
    },
    loadDealerCustomers() {
      //WITHOUT THIS nexttick, ENDPOINT WILL RETURN 401 --- WEIRD
      this.$nextTick(() => {
        this.$store
          .dispatch('orders/customer/getCustomers')
          .then((data) => {
            this.customersList = data.data;
          })
          .catch((e) => {});
      });
    },
    createCustomer() {
      let vm = this;
      vm.addNewCustomer = true;
      // vm.resetOrder()
      //   .then(() => {
      //     vm.setResidential(false);
      //     vm.setOrderType(2);
      //     vm.$router.push({
      //       path: `create-company`,
      //     });
      //   })
      //   .catch(() => { });
    },
    close() {
      let vm = this;
      vm.$store.commit('orders/changeLessee/setCreateOnly', false);
      vm.$emit('close', []);
    },
    navigateLesseeOrder() {
      let vm = this;
      vm.$router.push(`change-lessee`);
    },
    isValid(customer) {
      let vm = this;
      if (vm.SearchText === null) return true;

      const filters = ['ubAccountNo', 'firstName', 'surname'];
      for (var i = 0; i < filters.length; i++) {
        if (typeof customer[filters[i]] == 'undefined') return true;
        if (typeof customer[filters[i]] == 'string') {
          if (
            customer[filters[i]]
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        } else {
          if (
            customer[filters[i]]
              .toString()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
      if (typeof customer.companyDetails != 'undefined') {
        if (
          customer.companyDetails !== null &&
          customer.companyDetails.companyName !== null
        ) {
          if (
            customer.companyDetails.companyName
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }

      return false;
    },
    newCustomerSelect(props) {
      let vm = this;
      vm.selectedNewCust = props && props.item && props.item.ubAccountNo;
      vm.assignNewCustomer(props.item);
    },
    formerCustomerSelect(props) {
      let vm = this;
      vm.selectedFormerCust = props && props.item && props.item.ubAccountNo;
      vm.assignFormerCustomer(props.item);
    },
  },
  computed: {
    filteredRows() {
      // let vm = this;
      // return vm.customerData.filter(vm.isValid);
    },
    processChangeOfLessee() {
      return this.$store.getters['orders/changeLessee/processingChangeOfLesse'];
    },
  },
  mounted() {
    // this.$store.dispatch('orders/company/resetCompany');
    // this.$store.dispatch('orders/customer/resetCustomer');
    // this.$store.dispatch('orders/address/resetAddress');
    this.$store.dispatch('orders/resetOrder');
    this.loadDealerCustomers();
  },
};
</script>
